import { useContext } from 'react';
import { PiPContext, PiPContextType } from '../context/pip-context';

export const  usePiPWindow = (): PiPContextType =>  {
  const context = useContext(PiPContext);

  if (context === undefined) {
    throw new Error('usePiPWindow must be used within a PiPContext');
  }

  return context;
}
